import React, { useContext, useEffect, useState } from 'react'

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import tarjetasIcon from "../assets/img/tarjetas.svg";
import ConexContext from '../context/ConexContext';
import { useNavigate } from 'react-router-dom';
import { formatFecha } from './JS/formato';
import { ReactComponent as ArrowDown } from "../assets/img/arrowtable.svg";
// import { ReactComponent as IconTrash } from "../assets/img/icon-trash.svg";
import { ReactComponent as IconEdit } from "../assets/img/icon-edit.svg";

const Tarjetas = () => {
	const { peticion, tipo_usuario } = useContext(ConexContext);
	const navigate = useNavigate();
	const [datosTarj, setDatosTarj] = useState(null); //datos de tarjetas
	const [orden, setOrden] = useState({
		campo: 'pan_mask',
		orden: 'asc'
	}); //orden de la tabla

	const [filtros, setFiltros] = useState({ //filtros
		entidad: '',
		empresa: '',
		buscar: ''
	});
	const [entidades, setEntidades] = useState({}); //listado de entidades con las empresas

	/**
	 * Carga los datos de las tarjetas
	 */
	useEffect(() => {
		const listado_tarjetas = async () => {
			let res = await peticion(`/listado_tarjetas`, { method: 'GET' });
			if (res?.estado ?? true) return;
			if (res?.res ?? false) {
				setDatosTarj(res["res"]);
				//obtener entidades y empresas para filtrar
				const entidadesObj = {};
				res["res"].forEach(usuario => {
					const entidadCod = usuario.cod_ent;
					const entidadNombre = usuario.nombre_ent;
					const empresaNombre = usuario.nombre_emp;

					if (!entidadesObj[entidadCod]) {
							entidadesObj[entidadCod] = {
									cod: entidadCod,
									nombre: entidadNombre,
									empresas: []
							};
					}
					if (!entidadesObj[entidadCod].empresas.includes(empresaNombre))
						entidadesObj[entidadCod].empresas.push(empresaNombre);
				});
				setEntidades(entidadesObj);
			}
		}
		if (tipo_usuario === '5' || tipo_usuario === '2' || tipo_usuario === '0' || tipo_usuario === '3')
			listado_tarjetas();
	}, [tipo_usuario, peticion]);

	/**
	 * Ordena la tabla
	 * @param {String} campo Campo por el que se ordena 
	 */
	const ordenar = (campo) => {
		if (orden.campo === campo) {
			setOrden({
				campo: campo,
				orden: orden.orden === 'asc' ? 'desc' : 'asc'
			});
		} else {
			setOrden({
				campo: campo,
				orden: 'asc'
			});
		}
	}

	return (
		<>
			<div className="col-xs-12 tabla" id='user-mng' >
				<div className='section-header'>
					<div className='img-container'>
						<img src={tarjetasIcon} alt=''></img>
					</div>
					<div>
						<h2>Gestión de tarjetas</h2>
						<h6><strong>Listado</strong></h6>
					</div>
				</div>
				<main>
					<h3>Filtrar por:</h3>
					<div className="filtering__container">
						<div className="filtering">
							<select id="entidad" name="entidad"
								onChange={(e) => setFiltros({ ...filtros, entidad: e.target.value, empresa: ''})}
							>
								<option value="">Selecciona una entidad</option>
								{
									Object.keys(entidades).map((entidadCod, index) => (
										<option key={index} value={entidadCod}>{entidades[entidadCod].nombre}</option>
									))

								}
							</select>
						</div>
						<div className="filtering">
							<select id="tipo-usuario" name="tipo-usuario"
								onChange={(e) => setFiltros({ ...filtros, empresa: e.target.value })}
								disabled={filtros.entidad === ''}
							>
								<option value="">Selecciona una empresa</option>
								{
									Object.keys(entidades)
										.filter(entidadCod => entidades[entidadCod].cod === filtros.entidad)
										.map((entidadCod, index) => (
											entidades[entidadCod].empresas.map((empresa, index) => (
												<option key={index} value={empresa}>{empresa}</option>
											))
										))
								}
							</select>
						</div>
						<div className='filtering'>
							<input 
								type='text' 
								placeholder='Buscar...' 
								onChange={(e) => setFiltros({ ...filtros, buscar: e.target.value })}
							/>
						</div>
					</div>
					<div className="col-xs-12 cabeceratabla">
						<div className="col-xs-12 cont_cabeceratabla">
							<table>
								<tbody>
									<tr>
										<td 
											onClick={() => ordenar('pan_mask')}
											className={orden.campo === 'pan_mask' ? `order-${orden.orden}` : ''}
										>
											Número de tarjeta
											{orden.campo === 'pan_mask' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_ent')}
											className={orden.campo === 'nombre_ent' ? `order-${orden.orden}` : ''}
										>
											Entidad
											{orden.campo === 'nombre_ent' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_emp')}
											className={orden.campo === 'nombre_emp' ? `order-${orden.orden}` : ''}
										>
											Empresa
											{orden.campo === 'nombre_emp' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_dpto')}
											className={orden.campo === 'nombre_dpto' ? `order-${orden.orden}` : ''}
										>
											Departamento
											{orden.campo === 'nombre_dpto' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nombre_usuario')}
											className={orden.campo === 'nombre_usuario' ? `order-${orden.orden}` : ''}
										>
											Titular
											{orden.campo === 'nombre_usuario' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('nif_tarjeta')}
											className={orden.campo === 'nif_tarjeta' ? `order-${orden.orden}` : ''}
										>
											NIF del titular
											{orden.campo === 'nif_tarjeta' && <ArrowDown />}
										</td>
										<td 
											onClick={() => ordenar('fecha_alta')}
											className={orden.campo === 'fecha_alta' ? `order-${orden.orden}` : ''}
										>
											Fecha de alta
											{orden.campo === 'fecha_alta' && <ArrowDown />}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div className='tabladatos'>
						<div className="col-xs-12 cont_tabladatos">

							{!datosTarj ?
								<h1 className="cargando">Cargando...</h1>
								:
								<table>
									<tbody>
										{
											datosTarj
												.filter(tarj => { //filtrar por entidad y empresa
													if (filtros.entidad !== '' && tarj.cod_ent !== filtros.entidad) return false;
													if (filtros.empresa !== '' && tarj.nombre_emp !== filtros.empresa) return false;
													return true;
												})
												.filter(tarj => { //filtrar por búsqueda en nombre, email, entidad, empresa, departamento, código de usuario y nif
													if (filtros.buscar !== '' && 
														(
															!tarj.nombre_ent.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!tarj.nombre_emp.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!tarj.nombre_dpto.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!tarj.nombre_usuario.toLowerCase().includes(filtros.buscar.toLowerCase()) &&
															!tarj.nif_tarjeta.toLowerCase().includes(filtros.buscar.toLowerCase())
														)
													) return false;
													return true;
												})
												.sort((a, b) => {
													if (orden.orden === 'asc') {
														if (a[orden.campo] > b[orden.campo]) return 1;
														if (a[orden.campo] < b[orden.campo]) return -1;
														return 0;
													} else {
														if (a[orden.campo] < b[orden.campo]) return 1;
														if (a[orden.campo] > b[orden.campo]) return -1;
														return 0;
													}
												})
												.map((tarjeta, index) => (

													<tr key={index}>
														<td>
															<div>
																{tarjeta.pan_mask}
															</div>
														</td>
														<td>
															<div>
																{tarjeta.nombre_ent}
															</div>
														</td>
														<td>
															<div>
																{tarjeta.nombre_emp}
															</div>
														</td>
														<td>
															<div>
																{tarjeta.nombre_dpto}
															</div>
														</td>
														<td>
															<div>
																{tarjeta.nombre_usuario}
															</div>
														</td>
														<td>
															<div>
																{tarjeta.nif_tarjeta}
															</div>
														</td>
														<td>
															<div>
																{formatFecha(tarjeta.fecha_alta.toString(), "ISO8601", "esp")}
															</div>
															<div className="icon-container">
																<div>
																	<IconEdit
																		alt="Editar"
																		onClick={() => { navigate('/tarjeta/' + tarjeta.pan) }}
																	/>
																</div>
															</div>
														</td>
													</tr>
												))
										}
									</tbody>
								</table>
							}
						</div>
					</div>
					{/* <div className='button-container'>
						<button className='cta' onClick={() => navigate('/tarjeta/')}>Crear tarjeta</button>
					</div> */}
				</main>
			</div >
		</>
	)
}

export default Tarjetas;